export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      display: "flex",
    },
  },
  root: {
    display: "flex",
    [theme.breakpoints.down(650)]: { marginBottom: 80 },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    [theme.breakpoints.up(650)]: {
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  },
  paper: {
    paddingTop: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 24,
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
  titleTextStyle: {
    fontSize: 20,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    color: "#181818",
  },
  countStyle: {
    fontWeight: "bold",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    color: "#181818",
  },
});
